// extracted by mini-css-extract-plugin
export var baseButton = "_oq-0";
export var controlsArrowKeys = "_oq-1";
export var controlsResetButton = "_oq-2";
export var lightGameButton = "_oq-4 _oq-0";
export var playAgainButton = "_oq-5 _oq-0";
export var startGameButton = "_oq-3 _oq-0";